

export const appMealTypes = ['Πρωινό', 'Μεσημεριανό', 'Βραδινό', 'Ενδιάμεσο', 'Άσκηση', 'Γεγονός'];

export const Constants = {
    apiUrl: process.env.VUE_APP_API,
    marketplaceUrl: process.env.VUE_APP_VRES_URL || 'https://www.vresdiatrofologo.gr',
}